import { render, staticRenderFns } from "./home_seckill.vue?vue&type=template&id=4b7151d2&scoped=true&"
import script from "./home_seckill.vue?vue&type=script&lang=js&"
export * from "./home_seckill.vue?vue&type=script&lang=js&"
import style0 from "./home_seckill.vue?vue&type=style&index=0&id=4b7151d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7151d2",
  null
  
)

export default component.exports